import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom'
import { UserProvider } from './contexts/UserContextNew.tsx'
import { ThemeProvider } from './contexts/ThemeContext.tsx'
import ErrorBoundary from './components/ErrorBoundary.tsx'
// Initialises react-i18next before the first render (docs/TRANSLATION_SPEC.md §13).
import './i18n'
import './index.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
// Add global error handler
window.addEventListener('error', (event) => {});

window.addEventListener('unhandledrejection', (event) => {});

const root = document.getElementById('root');
if (!root) {} else {
  try {
    ReactDOM.createRoot(root).render(
      <React.StrictMode>
        <ErrorBoundary>
          <BrowserRouter>
            <ThemeProvider>
              <UserProvider>
                <App />
              </UserProvider>
            </ThemeProvider>
          </BrowserRouter>
        </ErrorBoundary>
      </React.StrictMode>
    );  } catch (error) {  }
}
